module.exports = __webpack_public_path__ + "6e13e5205b014c45e05e11a6462c6651.svg";